import React from 'react'
import { Field, FieldProps } from 'formik'
import objectPath from 'object-path'

import Textarea, { TextareaProps } from '../../controls/Textarea'

interface TextareaFieldProps extends TextareaProps {
  validateWithTouched?: boolean
}

const TextareaField: React.FC<TextareaFieldProps> = ({ validateWithTouched, ...props }) => (
  <Field {...props}>
    {({ field, form, meta: { touched } }: FieldProps<string>) => {
      const { isSubmitting } = form
      const error = objectPath.get(form.errors, field.name)
      const fieldError = validateWithTouched ? touched && error : error

      const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        form.setFieldValue(field.name, event.target.value)
        form.setFieldTouched(field.name)
        props.onChange && props.onChange(event)
      }

      return (
        <Textarea
          {...field}
          {...props}
          value={field.value || ''}
          error={fieldError}
          disabled={isSubmitting || props.disabled}
          onChange={handleChange}
        />
      )
    }}
  </Field>
)

TextareaField.defaultProps = {
  validateWithTouched: false
}

export default TextareaField
